enum NodeType {
    STOP = 'P',
    CROSSROAD = 'X',
    MUNICIPALITY_BORDER = '-',
}

export default NodeType;
